import React from 'react';
import moment from 'moment-timezone';
import { Typography, List, Card } from 'antd';
import { getGlobalAverage } from '../../../utils/informUtils';
import LeadershipByLeaders from '../components/leadershipByLeaders/leadershipByLeaders';
import AutoSizeTitle from '../components/autoSizeTitle/AutoSizeTitle';

const { Title, Text } = Typography;

const PageResultsByEmployee = ({ selectedEvaluation, totalResults, individualResults, pageNumber }) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation.evl_title} />

                <div className="internal-page-info">
                    <Card
                        style={{
                            borderRadius: '8px',
                            border: '1px solid #d9d9d9',
                            backgroundColor: '#fafafaff',
                            boxShadow: 'none',
                        }}
                        styles={{ body: { padding: '16px 24px' } }}
                    >
                        <Title level={4} style={{ color: '#339C98', marginBottom: 16 }}>
                            Resultados generales por líder
                        </Title>

                        <LeadershipByLeaders
                            data={individualResults}
                            globalAverage={getGlobalAverage(totalResults)}
                            redLight={selectedEvaluation.evl_max_red_light}
                            yellowLight={selectedEvaluation.evl_max_yellow_light}
                            serviceId={selectedEvaluation?.evl_srv_id}
                        />
                    </Card>
                </div>

                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageResultsByEmployee;





